export enum PathLabelType {
  QR_CODE = 'QRCODE',
  TEXT = 'TEXT'
}
